/**
 * Cart page micro-interactions.
 *
 * The cart markup (items, totals) is server-rendered and refreshed by
 * Horizon's cart morph, so this script holds no cart state. It watches the DOM
 * and counts the estimated total up/down when it changes.
 */

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** @param {string} text @returns {{ value: number, raw: string, decimals: number } | null} */
function parseMoney(text) {
  const match = text.match(/\d[\d.,]*/);
  if (!match) return null;
  const raw = match[0];
  const dot = raw.lastIndexOf('.');
  const decimals = dot === -1 ? 0 : raw.length - dot - 1;
  return { value: parseFloat(raw.replace(/,/g, '')), raw, decimals };
}

class CartCreative {
  #lastTotal = null;
  #animating = false;
  #scheduled = false;

  init() {
    this.#sync(true);
    const observer = new MutationObserver(() => {
      if (this.#animating || this.#scheduled) return;
      this.#scheduled = true;
      requestAnimationFrame(() => {
        this.#scheduled = false;
        this.#sync(false);
      });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true });
  }

  #sync(initial) {
    const totalEl = document.querySelector('.cart-page [data-cart-subtotal]');
    if (totalEl) {
      const parsed = parseMoney(totalEl.textContent);
      if (parsed) {
        const from = this.#lastTotal;
        this.#lastTotal = parsed.value;
        if (!initial && from !== null && from !== parsed.value && !REDUCED_MOTION) {
          this.#countUp(totalEl, from, parsed);
        }
      }
    }
  }

  /** @param {Element} el @param {number} from @param {{ value: number, raw: string, decimals: number }} to */
  #countUp(el, from, to) {
    const template = el.textContent;
    const duration = 450;
    const start = performance.now();
    this.#animating = true;

    const frame = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = from + (to.value - from) * eased;
      const formatted = current.toFixed(to.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = template.replace(to.raw, formatted);
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = template;
        // release the guard after the observer has seen our last write
        requestAnimationFrame(() => {
          this.#animating = false;
        });
      }
    };
    requestAnimationFrame(frame);
  }
}

if (document.querySelector('.cart-page')) {
  const cartCreative = new CartCreative();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cartCreative.init());
  } else {
    cartCreative.init();
  }
}
